import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

type Props = {
  title: string;
  onClose: () => void;
  onConfirm: (props: { setLoading: (loading: boolean) => void }) => void;
  children?: React.ReactNode;
  color?: 'error' | 'warning' | 'success';
  confirmText?: string;
};

export default function ConfirmModal({
  title,
  confirmText = 'Confirm',
  onClose,
  onConfirm,
  children,
  color = 'error',
}: Props) {
  const [loading, setLoading] = React.useState(false);
  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open
      onClose={onClose}
      sx={{ '& .MuiDialog-paper': { borderRadius: '20px' } }}
    >
      <DialogTitle sx={{ padding: '32px 24px 16px' }}>{title}</DialogTitle>
      <DialogContent sx={{ padding: '16px 24px' }}>{children}</DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button
          onClick={() => {
            onConfirm({ setLoading });
          }}
          color={color}
          variant="contained"
          disabled={loading}
        >
          {confirmText}
        </Button>
        <Button variant="outlined" color="secondary" onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
